import { render, staticRenderFns } from "./AIPrincipalTokens.vue?vue&type=template&id=5d70b0ba&scoped=true&"
import script from "./AIPrincipalTokens.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIPrincipalTokens.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIPrincipalTokens.vue?vue&type=style&index=0&id=5d70b0ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70b0ba",
  null
  
)

export default component.exports